export const OPPORTUNITY_STATUS = {
  TOTAL: 'total',
  PENDING_PAYMENT: 'pending_payment',
  PAYMENT_MADE: 'payment_made',
  PARTIALLY_PAID_UNVERIFIED: 'partially_paid_unverified',
  PAID_UNVERIFIED: 'paid_unverified',
  PAID_VERIFIED: 'paid_verified',
  APPROVED: 'approved',
  VERIFICATION_REJECTED: 'verification_rejected',
  PENDING_CANCELLATION: 'pending_cancellation',
  CANCELLED: 'cancelled',
  // CPI-1226 (Vietnam only): the terminal status of a cancellation whose recorded scenario was
  // "due to error". `cancelled` now means "due to buyer, or no scenario recorded".
  CANCELLED_ERROR: 'cancelled_error',
  PENDING_REFUND: 'pending_refund',
  REFUNDED: 'refunded',
  REFUND_DECLINED: 'refund_declined',
  EXPIRED: 'expired',
};

export const OPPORTUNITY_STATUS_GROUP = {
  TOTAL: 'total',
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  PENDING_CLOSURE: 'pending_closure',
  PENDING_REFUND: 'pending_refund',
  CLOSED: 'closed',
  // CPI-1226: mhub-opportunity-api's SRGroupStatuses gained an `error` group holding
  // cancelled_error, and showroom/summary emits a matching `error` key. Vietnam only -- a
  // Malaysian summary never carries it, and this whole screen is Vietnam-only anyway.
  ERROR: 'error',
};

export const SINGLE_STATUS_FILTER_OPTIONS = [
  { value: 'pending_payment', text: 'Pending Payment' },
  { value: 'payment_made', text: 'Payment Made' },
  { value: 'partially_paid_unverified', text: 'Partial Paid' },
  { value: 'paid_unverified', text: 'Paid Unverified' },
  { value: 'paid_verified', text: 'Paid Verified' },
  { value: 'approved', text: 'Approved' },
  { value: 'verification_rejected', text: 'Verification Rejected' },
  { value: 'pending_cancellation', text: 'Pending Cancellation' },
  { value: 'cancelled', text: 'Cancelled' },
  // Required, not cosmetic: renderBookingStatus falls back to SINGLE_STATUS_MAP[PENDING_PAYMENT]
  // for an unmapped sr_status, so without this row every error-cancelled booking would render
  // its status chip as "Pending Payment".
  { value: 'cancelled_error', text: 'Cancelled (Error)' },
  { value: 'pending_refund', text: 'Pending Refund' },
  { value: 'refunded', text: 'Refunded' },
  { value: 'refund_declined', text: 'Refund Declined' },
  { value: 'expired', text: 'Expired' },
];

export const OPPORTUNITY_STATUSES_TABS = [
  { text: 'All Bookings', header: 'All bookings', value: OPPORTUNITY_STATUS_GROUP.TOTAL, name: OPPORTUNITY_STATUS_GROUP.TOTAL, className: 'uc-opportunity-total' },
  { text: 'Pending Approval', header: 'Pending approval bookings', value: OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL, name: OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL, className: 'uc-opportunity-pending_approval' },
  { text: 'Approved', header: 'Approved bookings', value: OPPORTUNITY_STATUS_GROUP.APPROVED, name: OPPORTUNITY_STATUS_GROUP.APPROVED, className: 'uc-opportunity-approved' },
  { text: 'Pending Closure', header: 'Pending closure bookings', value: OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE, name: OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE, className: 'uc-opportunity-pending_closure' },
  { text: 'Pending Refund', header: 'Pending refund bookings', value: OPPORTUNITY_STATUS_GROUP.PENDING_REFUND, name: OPPORTUNITY_STATUS_GROUP.PENDING_REFUND, className: 'uc-opportunity-pending_refund' },
  { text: 'Closed', header: 'Closed bookings', value: OPPORTUNITY_STATUS_GROUP.CLOSED, name: OPPORTUNITY_STATUS_GROUP.CLOSED, className: 'uc-opportunity-closed' },
  // CPI-1226: a plain group tab. It used to be a client-side carve-out of `cancelled` out of
  // Closed, because mhub-opportunity-api's SRGroupStatuses had no group for it and
  // showroom/summary had no counterpart key. Both now exist (`error` -> {cancelled_error}), so
  // this drives `group_status` exactly like the six tabs above it and the carve-out machinery in
  // OpportunityList.jsx is gone.
  //
  // The tab no longer holds every cancellation: buyer cancellations stay `cancelled` and are
  // counted under Closed, which is the point of the split. Existing rows have no recorded
  // scenario, so they read as buyer cancellations and move to Closed on the day this ships.
  //
  // No country check: this whole screen is Vietnam-only already. Both entry points route to
  // /opportunities/ only for VN and to /bookings/ otherwise (containers/BookApp.jsx and
  // containers/BookDash.jsx), and nothing outside components/Opportunities/ reads these tabs.
  // `className` stays `uc-opportunity-cancelled` so the existing styling still applies. The
  // 'Cancelled' translation key is deliberately NOT reused -- it is shared across booking lists,
  // token payments, the loan tracker and more, so editing it would rename all of those.
  { text: 'Error', header: 'Error bookings', value: OPPORTUNITY_STATUS_GROUP.ERROR, name: OPPORTUNITY_STATUS_GROUP.ERROR, className: 'uc-opportunity-cancelled' },
];

// Values of the tabs that filter by sr_status rather than group_status. Empty since CPI-1226
// re-pointed the Error tab at a real group; kept because the derivation is what makes it empty,
// and a future sr_status tab only has to set `singleStatus: true` again.
export const SINGLE_STATUS_TAB_VALUES = OPPORTUNITY_STATUSES_TABS
  .filter(tab => tab.singleStatus)
  .map(tab => tab.value);

export const OPPORTUNITY_STATUS_MAP = OPPORTUNITY_STATUSES_TABS.reduce(
  (acc, tab) => ({
    ...acc,
    [tab.value]: tab,
  }),
  {},
);

export const SINGLE_STATUS_MAP = SINGLE_STATUS_FILTER_OPTIONS.reduce(
  (acc, option) => ({
    ...acc,
    [option.value]: option,
  }),
  {},
);

export const DEFAULT_OPPORTUNITY_STATUS = OPPORTUNITY_STATUS_GROUP.TOTAL;



// WEBPACK FOOTER //
// ./src/constants/opportunityStatuses.js